/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */

import React from "react";
import Logo from "../../Images/Logo.svg";
import { MdLocationOn, MdOutlineMail } from "react-icons/md";
import { FaPhone, } from "react-icons/fa";
import { BiRightArrowAlt } from "react-icons/bi"; // Corrected icon import
import { Link } from "react-router-dom";

const Footer = () => {
  const date = new Date();
  return (
    <>
      <div className="m-0 box-border font-Urbanist bg-footerBg">
        <div className="w-[92%] mx-auto font-Urbanist font-semibold p-4 gap-6 md:gap-4 lg:gap-1 flex flex-col md:flex-row justify-start md:justify-between items-start md:items-center">
          <div className="w-[200px] pb-4">
            <img src={Logo} alt="" className="w-[150px]" />
            <p className="text-white">
              At PMC, we have customer interest at the heart of our business,and
              at such, we have various options to meet your needs.
            </p>
          </div>
          <div className=" w-[250px] text-white">
            <h3 className="font-bold text-2xl py-4">Contact Info</h3>
            <div className="flex justify-start pb-4 items-start gap-2">
              <MdLocationOn className="text-4xl text-[#67757F]" />
              <p className="text-base">
                25, Edgehill Road, Leicester LE4 9EA United Kingdom
              </p>
            </div>
            <div className="flex justify-start pb-4 items-center gap-4">
              <FaPhone className="text-[#67757F]" />
              <p>07916743112</p>
            </div>
            <div className="flex justify-start items-center  gap-2">
              <MdOutlineMail className="text-2xl text-[#67757F]" />
              <p className="text-base">manager@pmc-group.uk</p>
            </div>
          </div>
          <div className="w-[200px] cursor-pointer">
            <h3 className="font-bold text-2xl text-white py-4">Services</h3>
            <Link to="/about">
              <div className="flex justify-start items-center gap-2">
                <BiRightArrowAlt className="text-background hover:text-black" />
                <p className="text-white hover:text-background pb-2">
                  About PMC
                </p>
              </div>
            </Link>
            <Link to="/drain-unblocking">
              <div className="flex justify-start items-center gap-2">
                <BiRightArrowAlt className="text-background hover:text-black" />
                <p className="text-white hover:text-background pb-2">
                  Drain Unblocking
                </p>
              </div>
            </Link>
            <Link to="/waste-management">
              <div className="flex justify-start items-center gap-2">
                <BiRightArrowAlt className="text-background hover:text-black" />
                <p className="text-white hover:text-background pb-2">
                  Waste Management
                </p>
              </div>
            </Link>
            <Link to="/plumbing">
              <div className="flex justify-start items-center gap-2">
                <BiRightArrowAlt className="text-background hover:text-black" />
                <p className="text-white hover:text-background pb-2">
                  Plumbing
                </p>
              </div>
            </Link>
            <Link to="/kitchen">
              <div className="flex justify-start items-center gap-2">
                <BiRightArrowAlt className="text-background hover:text-black" />
                <p className="text-white hover:text-background pb-2">Kitchen</p>
              </div>
            </Link>
            <Link to="/haulage">
              <div className="flex justify-start items-center gap-2">
                <BiRightArrowAlt className="text-background hover:text-black" />
                <p className="text-white hover:text-background">
                  Haulage and Removal
                </p>
              </div>
            </Link>
          </div>
          {/* <div className="w-[200px]">
            <h3 className="font-bold text-2xl text-white py-4">Get in Touch</h3>
            <div className=" flex justify-start items-center cursor-pointer gap-4">
              <div className=" flex justify-center items-center w-[40px] h-[40px] bg-[#3B5958] rounded-full">
                <FaFacebookF className="text-white" />
              </div>
              <div className="flex justify-center items-center w-[40px] h-[40px] bg-[#1DA1F2] rounded-full">
                <BsTwitterX className="text-white" />
              </div>
              <div className="flex justify-center items-center w-[40px] h-[40px] bg-[#262626] rounded-full">
                <FaInstagram className="text-white" />
              </div>
              <div className="flex justify-center items-center w-[40px] h-[40px] bg-[#EA4335] rounded-full">
                <MdOutlineMail className="text-white" />
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div className="bg-white font-Urbanist ">
        <div className="w-[94%] h-[120px] mx-auto flex flex-col md:flex-row justify-start md:justify-between items-center pt-6 font-semibold text-black">
          <span>Copyright &copy;{date.getFullYear()} pmc</span>
          <span>Powered by pmc</span>
        </div>
      </div>
    </>
  );
};

export default Footer;
